import { styled } from 'styled-components';

import { CommonAction, designColor, recipesCommonAction, styledTypography } from '@pkg/primitives';

import { thumbnailOverflowWrapper } from '../../Thumbnail/Thumbnail.tokens';

import { tokens } from './FilterCollection.tokens.ts';

export const Action = styled(CommonAction)`
    ${recipesCommonAction.basic};
    justify-content: space-between;
    gap: ${tokens.action.gap}px;
    padding: ${tokens.action.padding}px;
    padding-right: ${tokens.action.padding * 2}px;
    border-radius: ${tokens.action.radius}px;
    width: 100%;
    text-align: left;
    background-color: rgb(255, 255, 255, 0);

    &:disabled {
        opacity: 0.8;
    }

    &:hover {
        background-color: rgb(255, 255, 255, 0.1);
    }

    &:active {
        background-color: rgb(255, 255, 255, 0.06);
    }

    &[aria-pressed] {
        background-color: ${designColor.brandPurple};

        &:hover {
            background-color: ${designColor.brandPurpleDark};
        }

        &:active {
            background-color: ${designColor.brandPurple};
        }
    }
`;

export const Content = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: ${tokens.content.gap}px;
`;

export const ThumbnailWrapper = styled.div`
    ${thumbnailOverflowWrapper(tokens.thumbnail.radius)};
    flex: 0 0 auto;
    width: ${tokens.thumbnail.size}px;
    height: ${tokens.thumbnail.size}px;
`;

export const Name = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.truncate};
    ${styledTypography.truncateHeightFix()};
    font-size: ${tokens.name.size}px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;

export const SupplyLabel = styled.p`
    ${styledTypography.allianceBase};
    font-size: ${tokens.supply.size}px;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.4);

    strong {
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        color: rgb(255, 255, 255, 1);
    }
`;
